import * as React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import media from '../../../services/generateMediaQueries'

const StyledCatalogList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 -0.5rem;

  ${media.lessThan('small')`
    margin: 0 1rem;

    > .react-reveal {
      width: 100%;
    }
  `}
`

const CatalogList = ({
  renderItem,
  dataSource = [],
  loadingComponent: LoadingComponent,
  ...restProps
}) => (
  <StyledCatalogList {...restProps}>
    {!dataSource.length &&
      LoadingComponent &&
      Array(3)
        .fill(null)
        // eslint-disable-next-line react/no-array-index-key
        .map((val, index) => <LoadingComponent key={`loading-${index}`} />)}
    {renderItem && dataSource.map(renderItem)}
  </StyledCatalogList>
)

CatalogList.propTypes = {
  dataSource: PropTypes.array,
  renderItem: PropTypes.func,
}

export default CatalogList
